export default "__VITE_ASSET__DdsvdsQK__"